<template>
  <div>
    <DeleteModal modalId="modal-delete" @deleteToggle="deleteItem" />

    <b-modal
      :no-close-on-backdrop="true"
      id="modal-edit"
      ok-only
      centered
      size="lg"
      :title="
        createMode ? $t('emergency.Add-Emergency-Service') : $t('emergency.Edit-Emergency-Service')
      "
    >
      <b-card-text>
        <b-row>
          <b-col md="">
            <b-form-group :label="$t('common.title')" label-for="name">
              <b-form-input
                v-model="EditForm.title"
                :placeholder="$t('common.title')"
              />
              <p class="text-danger mt-1">{{ errorForm.title }}</p>
            </b-form-group>
          </b-col>
          <b-col md="">
            <b-form-group :label="$t('common.price')" label-for="name">
              <b-form-input
                v-model="EditForm.price"
                :placeholder="$t('common.price')"
              />
              <p class="text-danger mt-1">{{ errorForm.price }}</p>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
      <template #modal-footer="{}">
        <b-button
          variant="primary"
          @click="submitItem"
          class="m-0"
          :disabled="loading"
          ref="button"
          block
        >
          <span v-if="!loading">{{ $t("common.add") }}</span>
          <b-spinner small v-else></b-spinner>
        </b-button>
      </template>
    </b-modal>
    <b-card :title="$t('emergency.emergency-services')">
      <div>
        <b-row>
          <b-col cols="12" md="12">
            <h2>{{ $t("emergency.Filter-Emergency-Services") }}</h2>
            <br />
          </b-col>

          <b-col md="4" cols="12">
            <b-form-group :label="$t('common.title')" label-for="Name">
              <b-form-input
                id="Name"
                v-model="floorName"
                :placeholder="$t('common.title')"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Search Button -->
        <b-row>
          <b-col cols="12" md="12">
            <br />
          </b-col>
          <b-col
            cols="12"
            md="12"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <b-button variant="primary" @click="getEmergencyServicesList()">
              {{ $t("common.search") }}
              <b-icon-search class="ml-1"></b-icon-search>
            </b-button>
          </b-col>
        </b-row>
        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>{{ $t("emergency.emergency-services") }}</h2>
          <div>
            <!-- <b-button
              variant="warning"
              @click="injectTestServices"
              class="mr-2"
              v-if="$store.state.app.permissions.includes('store-service')"
            >
              {{ $t("emergency.inject-test-services") }}
            </b-button> -->
            <b-button
              variant="primary"
              @click="show(EditForm, 'create')"
              v-if="$store.state.app.permissions.includes('store-service')"
            >
              {{ $t("common.add") }}
            </b-button>
          </div>
        </div>

        <b-table
          :items="this.data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
          v-if="!loading"
        >
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <ActionsButtons
                deletePerm="delete-service"
                editPerm="update-service"
                @editToggle="show(data.item)"
                @deleteToggle="deleteModel(data.item)"
              />
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner :label="$t('common.loading')" />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Showing 1 to 10 Emergency Services</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getEmergencyServicesList()"
            >
              <b-pagination
                v-model="page"
                :total-rows="this.dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import permissionChecker from "@/mixins/permissionChecker";
import DeleteModal from "@/components/modals/DeleteModal.vue";
import ActionsButtons from "@/components/common/ActionsButtons.vue";

export default {
  mixins: [permissionChecker],
  components: {
    DeleteModal,
    BCard,
    ActionsButtons,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    VuePhoneNumberInput,
  },
  data() {
    return {
      take: 10,
      loading: true,
      isNotValid: false,
      dataCount: 0,
      data: [],
      EditForm: {
        title: "",
        price: "",
        type: "emergency",
        _method: "PUT",
      },
      createMode: false,
      errorForm: {
        title: "",
        price: "",
      },
      params: {
        form: {},
        path: "",
      },
      tableColumns: [
        { key: "title", sortable: true, label: this.$t("common.title") },
        { key: "price", sortable: true, label: this.$t("common.price") },

        { key: "Actions", label: this.$t("common.actions") },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
    };
  },
  mounted() {
    this.getEmergencyServicesList();
  },
  methods: {
    show(item, mode) {
      if (mode === "create") {
        this.createMode = true;
        this.EditForm = {
          title: "",
          price: "",
          type: "emergency",
          _method: "POST",
        };
      } else {
        this.createMode = false;

        this.EditForm.id = item.id;
        this.EditForm.title = item.title;
        this.EditForm.price = item.price;
        this.EditForm.type = "emergency";
        this.EditForm._method = "PUT";
      }
      this.$bvModal.show("modal-edit");
    },
    showPhoneObj(obj, countryCallingCodeCheck) {
      this.isNotValid = !obj.isValid;
      countryCallingCodeCheck
        ? (this.countryCallingCodeFirst = obj.countryCallingCode)
        : (this.countryCallingCodeSecond = obj.countryCallingCode);
    },
    async getEmergencyServicesList() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/service?page=${this.page}&take=${this.take}&sort=-id`;

      if (this.floorName) {
        url += `&filter[title]=${this.floorName}`;
      }

      await this.getList(url);
      
      // Filter emergency services on frontend since backend doesn't support type filter yet
      const allServices = this.all_data.data;
      const emergencyServices = allServices.filter(service => service.type === 'emergency');
      
      this.dataCount = emergencyServices.length;
      this.data = emergencyServices;
      this.loading = false;
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-delete");
    },
    deleteItem() {
      this.$store
        .dispatch("delete", `/service/${this.deleteForm.id}`)
        .then((response) => {
          this.getEmergencyServicesList();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: "deleted " + this.deleteForm.title + " successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.title,
            },
          });
        });
    },
    async injectTestServices() {
      this.loading = true;
      
      const testServices = [
        { title: "Emergency Triage", price: "50000" },
        { title: "Emergency Consultation", price: "75000" },
        { title: "Emergency X-Ray", price: "100000" },
        { title: "Emergency Blood Test", price: "25000" },
        { title: "Emergency ECG", price: "30000" },
        { title: "Emergency Ultrasound", price: "80000" },
        { title: "Emergency CT Scan", price: "200000" },
        { title: "Emergency MRI", price: "300000" },
        { title: "Emergency Surgery", price: "500000" },
        { title: "Emergency Anesthesia", price: "150000" },
        { title: "Emergency ICU Care", price: "200000" },
        { title: "Emergency Ventilator", price: "100000" },
        { title: "Emergency Medication", price: "50000" },
        { title: "Emergency Transport", price: "75000" },
        { title: "Emergency Discharge", price: "25000" }
      ];

      let successCount = 0;
      let errorCount = 0;

      for (const service of testServices) {
        try {
          const payload = {
            title: service.title,
            price: service.price,
            type: "emergency",
            _method: "POST"
          };

          await this.$store.dispatch("create", {
            form: payload,
            path: "/service"
          });
          
          successCount++;
        } catch (error) {
          errorCount++;
          console.error(`Failed to create service: ${service.title}`, error);
        }
      }

      this.loading = false;
      
      // Show result message
      this.$toast({
        component: ToastificationContent,
        position: "top-right",
        props: {
          title: "Test Services Injection",
          variant: successCount > 0 ? "success" : "danger",
          text: `Successfully created ${successCount} services. ${errorCount > 0 ? `${errorCount} failed.` : ''}`,
        },
      });

      // Refresh the list
      this.getEmergencyServicesList();
    },
    submitItem() {
      this.loading = true;
      let count = 0;
      this.errorForm.title = "";
      this.errorForm.price = "";
      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null)
          delete this.EditForm[item];
      }
      if (!this.EditForm.title) {
        count++;
        this.errorForm.title = "The title field is required.";
      }
      if (!this.EditForm.price) {
        count++;
        this.errorForm.price = "The price field is required.";
      }

      if (count > 0) {
        this.loading = false;
        return false;
      }

      if (this.createMode) {
        (this.params.form = this.EditForm),
          (this.params.path = `/service`),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              this.getEmergencyServicesList();
              this.loading = false;
              this.$bvModal.hide("modal-edit");
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditForm),
          (this.params.path = `/service/${this.EditForm.id}`),
          this.$store
            .dispatch("update", this.params)
            .then((response) => {
              this.getEmergencyServicesList();
              this.loading = false;
              this.$bvModal.hide("modal-edit");
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
